/**
 * Machu Picchu retreat marketing: listed in sitemap, conventions index, and
 * search promos only on/after this date (UTC midnight).
 */
const MACHU_RETREAT_PUBLIC_LISTING_UTC_MS = Date.UTC(2027, 4, 25, 0, 0, 0, 0)

export const MACHU_RETREAT_PAGE_PATH = '/magic-conventions/the-retreat-machu-picchu-2027/'

export function isMachuRetreatPubliclyListed(): boolean {
  return Date.now() >= MACHU_RETREAT_PUBLIC_LISTING_UTC_MS
}
